<script setup lang="ts">
import {reactive, ref} from "vue";
import { sections, canSeeSection } from "@/lib/auth/lighthouseAuth";

const active = ref(false);

const phoneNumber = "(866) 885-0316"

function toggleActive() {
  active.value = !active.value;
}

// Add this function to close the menu
function closeMenu() {
  active.value = false;
}

const siteInfo = reactive({
  address: reactive({
    title: "Corporate Address",
    content: [
      "3 Crossgate Drive",
      "Mechanicsburg, PA 17050"
    ]
  }),
  license: "PA HIC Registration Number: PA012954",
  phoneNumber: "(866) 885-0316"
});
</script>

<template>
  <div class="header-shelf">
    <div class="header-container container-fluid max-width-xl d-flex g-0">
      <div class="main-logo">
        <RouterLink to="/wshHome" target="_blank">
          <img src="@/assets/WSH-logo-BLUE.webp" alt="West Shore Home logo"/>
        </RouterLink>
      </div>

      <div class="links">
        <a class="telephone" :href="`tel:${phoneNumber}`">{{ phoneNumber }}</a>
        <a class="telephone-mobile" :href="`tel:${phoneNumber}`">
          <font-awesome-icon class="icon" icon="fa-solid fa-phone-alt"></font-awesome-icon>
        </a>
      </div>

      <div class="hamburger-menu">
        <button class="navbar-toggler third-button" @click="toggleActive">
          <div class="animated-hamburger-menu-icon" :class="[active && 'open']">
            <span></span><span></span><span></span>
          </div>
        </button>
      </div>
    </div>

    <div class="bg-overlay" :class="{ 'active': active }" @click.self="toggleActive"/>

    <div class="hamburger-flyout left-col col-lg-4" :class="{ 'active': active }">

      <div v-if ="canSeeSection(sections.support)" class="hamburger-flyout-item dashboard-flyout-nav">
        <ul class="dashboard-nav-list">
          <li>
            <RouterLink to="/dashboard" class="title parent-link" @click="closeMenu">Dashboard</RouterLink>
            <ul class="dashboard-nav-children">
              <li>
                <RouterLink to="/dashboard/documentTemplate" @click="closeMenu">Document Templates</RouterLink>
              </li>
              <li>
                <RouterLink to="/dashboard/signableDocument" @click="closeMenu">Signable Documents</RouterLink>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      
      <div class="hamburger-flyout-item site-info">
        <div class="title">{{siteInfo.address.title}}</div>
        <ul>
          <li v-for="item in siteInfo.address.content">
            {{item}}
          </li>
        </ul>
        <p>{{siteInfo.license}}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>

.header-shelf {
  max-height: 96px;
  position: fixed;
  margin: auto;
  display: -webkit-flex;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  width: 100%;
  background-color: white;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, .10);
  z-index: 100;
  
  .header-container {
    padding: 22px 30px 1em;
  }
}

.bg-overlay {
  pointer-events: none;
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 80;
  background-color: black;
  opacity: 0;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}

.bg-overlay.active {
  pointer-events: auto;
  opacity: 60%;
}

.main-logo {
  display: -webkit-box;
  -webkit-box-align: center;
  
  img {
    width: 100%;
    max-width: 225px;
    vertical-align: middle;
  }

  a {
    display: block;
  }

  a:hover {
    opacity: 0.7;
    background-color: white;
  }
}

.links {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.telephone {
  padding: 1em 1.5em;
  color: white;
  font-weight: 700;
  border-radius: 57px;
  background-color: #1B75BB;
}

.telephone:hover {
  color: #1B75BB;
  background-color: transparent;
  box-shadow: inset 0 0 0 2px #1B75BB;
}

.telephone-mobile {
  display: none;
  
  .icon {
    color: #ff8004;
    width: 30px;
    height: 30px;
  }
}

.telephone-mobile:hover {
  opacity: 0.7;
  background-color: transparent;
}

@media screen and (max-width: 600px) {
  .telephone {
    display: none;
  }

  .telephone-mobile {
    display: inline-block;
  }
}

.hamburger-menu {
  display: block;
  margin-left: 21px;
  margin-top: auto;
  margin-bottom: auto;
}

.hamburger-flyout {
  width: 0;
  max-width: 0;
  position: fixed;
  top: 95px;
  height: 100%;
  right: 0;
  z-index: 90;
  background-color: #0d0d50;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hamburger-flyout.active {
  width: 100%;
  max-width: 450px;
}

.animated-hamburger-menu-icon {
  width: 30px;
  height: 20px;
  position: relative;
  margin: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;
}

.animated-hamburger-menu-icon span {
  background: #0d0d50;
  display: block;
  position: absolute;
  height: 3px;
  width: 100%;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
}

.animated-hamburger-menu-icon span:nth-child(1) {
  top: 0;
  -webkit-transform-origin: left center;
  -moz-transform-origin: left center;
  -o-transform-origin: left center;
  transform-origin: left center;
}

.animated-hamburger-menu-icon span:nth-child(2) {
  top: 10px;
  -webkit-transform-origin: left center;
  -moz-transform-origin: left center;
  -o-transform-origin: left center;
  transform-origin: left center;
}

.animated-hamburger-menu-icon span:nth-child(3) {
  top: 20px;
  -webkit-transform-origin: left center;
  -moz-transform-origin: left center;
  -o-transform-origin: left center;
  transform-origin: left center;
}

.animated-hamburger-menu-icon.open span:nth-child(1) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  top: 0;
  left: 8px;
}

.animated-hamburger-menu-icon.open span:nth-child(2) {
  width: 0;
  opacity: 0;
}

.animated-hamburger-menu-icon.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
  top: 21px;
  left: 8px;
}

.hamburger-flyout-item {
  padding: 35px 35px 0 35px;
}

.site-info {
  color: white;
  font-size: 0.8rem;

  .title {
    font-size: 1.1rem;
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 0.5em;
    letter-spacing: .05em;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0 0 1.25em;
  }
}

.dashboard-flyout-nav {
  margin-top: 2em;
  color: white;
}
.dashboard-flyout-nav .title {
  font-size: 1.1rem;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 0.5em;
  letter-spacing: .05em;
}
.dashboard-nav-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.dashboard-nav-list > li {
  margin-bottom: 0.5em;
}
.dashboard-nav-list .parent-link {
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
}
.dashboard-nav-list .parent-link.router-link-exact-active {
  color: #ff8004;
}
.dashboard-nav-children {
  list-style-type: none;
  padding-left: 1.5em;
  margin: 0.25em 0 0 0;
}
.dashboard-nav-children li {
  margin-bottom: 0.25em;
}
.dashboard-nav-children a {
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
}
.dashboard-nav-children a.router-link-exact-active {
  color: #ff8004;
}
</style>